import { toDateOnly } from '@aston/foundation';

import { IContactForm, SalesConditionsDocument } from '../models';
import { IContactFormApi, SalesConditionsDocumentApi } from '../models/api';


export function mapToContactFormApiModel(model: IContactForm): IContactFormApi {
	return {
		lastName: model.lastName,
		firstName: model.firstName,
		email: model.email,
		phoneNumber: model.phoneNumber,
		subject: model.subject,
		body: model.body,
		canRecall: model.canRecall,
		recallDate: model.canRecall ? toDateOnly(model.recallDate) : null,
		recallTime: model.canRecall ? model.recallTime : null
	};
}

export function newContactForm(): IContactForm {
	return {
		lastName: '',
		firstName: '',
		email: '',
		phoneNumber: '',
		subject: '',
		body: '',
		canRecall: false,
		recallDate: null,
		recallTime: ''
	};
}

export function mapToSalesConditions(model: SalesConditionsDocumentApi): SalesConditionsDocument {
	return {
		size: null,
		category: null,
		documentType: null,
		id: model.documentFileId,
		documentId: model.id,
		mimeType: model.contentType,
		name: model.externalStorageId,
	};
}
